module.exports = __webpack_public_path__ + "static/media/21424_547145432018073_2138343967_n.f032048c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/21424_547145432018073_2138343967_n.jpg
// module id = 353
// module chunks = 0